import * as React from 'react';
import '../../../../checklists/_checklistListing.scss';
import AllChecklistsListing from './AllChecklistsListing';

export default function AllChecklists(): JSX.Element {
  return (
    <div style={{ display: 'flex' }}>
      <AllChecklistsListing />
    </div>
  );
}
